export class DataTableOptions {
	title = 'اطلاعات';
	countable = true;
	searchable = true;
	filterable = true;
	paginator = true;
}
